import React from 'react'
import Header from './header'
import style from '../styles/layout.module.scss'
import Footer from './footer'
import BaseLayout from './BaseLayout'
import ErrorBoundary from '@/components/ErrorBoundary'

const Layout = ({ isFooter = true, children }): React.ReactElement => {
  return (
    <BaseLayout>
      <Header />
      <main className={style.main}>
        <ErrorBoundary>
          {children}
        </ErrorBoundary>
      </main>
      {isFooter ? <Footer /> : ''}
    </BaseLayout>
  )
}

export default Layout
